import React from 'react';
import styles from './Details.module.scss';

export default function SectionTitle({ children }) {
  return <h2 className={styles.title}>{children}</h2>;
}
